import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs as importedSaveAs } from 'file-saver';
import { SnotifyService } from 'ng-snotify';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ViewEncapsulation } from '@angular/core';
import { ConfirmationService } from "primeng/api";
import { EquipmentService } from '../../../../services/equipment.service';
import { AuthService } from '../../../../services/auth.service';
import { Page } from '../../../../models/paging/page';
import { CompanyService } from '../../../../services/company.service';
import { Company } from '../../../../models/company';


@Component({
  selector: 'app-upload-assets',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class UploadAssetComponent implements OnInit {
  loading: boolean = false;
  company_Id: any;
  importFile = {
    fileData: "",
    company_Id: ""
  }
  readOnly: boolean = false;
  rows = [];
  page = new Page();
  company: Company;
  companyName: string = '';
  constructor(public equipmentService: EquipmentService, public router: Router, private authService: AuthService, public companyService: CompanyService,
    private snotifyService: SnotifyService) {
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'asc';
    this.page.sortBy = "serial";
  }


  ngOnInit(): void {
    this.company_Id = this.router.parseUrl(this.router.url).queryParams["id"];
    if (this.company_Id == null) {
      this.snotifyService.error("Error loading company");
      this.loading = false;
      this.router.navigate(['']);
    } else {
      this.companyService.get(this.company_Id).then((c) => {
        this.company = c;
        this.companyName = c.name;
      }, (err) => {
        this.snotifyService.error("Error loading company details");
        this.loading = false;
        this.router.navigate(['']);

      });
    }
  }

  uploadFile(e): void {
    var rawBase64 = null;
    var base64 = null;

    // If a file was selected
    if (e.target.files.length > 0) {

      let file = e.target.files[0];
      var reader = new FileReader();

      reader.readAsDataURL(file);

      // Split the initial data type string from the base64 data
      reader.onload = (e) => {
        rawBase64 = reader.result;
        base64 = rawBase64.split(",", 2);
        this.importFile.fileData = base64[1];
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    }
  }


  upload() {
    this.loading = true;
    console.log(this.importFile);
    this.importFile.company_Id = this.company_Id;
    this.equipmentService.postMassUpload(this.importFile).then((data) => {
      this.snotifyService.success("Successfully uploaded items");
      this.loading = false;
      this.back();
    }, (err) => {
      console.log(err);
      this.snotifyService.error(err.error);
      this.loading = false;
      this.importFile.fileData = null;
    });
  }

  back() {
    if (this.authService.currentUser.value.userProfileId == 3) {
      this.router.navigate(['']);
    } else {
      this.router.navigate(['admin/companies/overview'], { queryParams: { id: this.company_Id } });
    }
  }
}